import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import * as confetti from 'canvas-confetti';

@Component({
  selector: 'lib-confetti',
  templateUrl: './confetti.component.html',
  styleUrl: './confetti.component.scss'
})
export class LibConfettiComponent {

  @ViewChild('canvas') canvas: ElementRef | null = null; 

  @Input() particle_count = 100
  @Input() spread = 160
  @Input() origin: confetti.Origin = { y: 0.6 }
  @Input() duration = 5000

  ngAfterViewInit() {
    if (this.canvas) {
      this.fire();
    }
  }

  fire() {
    if (this.canvas) {

      var myConfetti = confetti.create(this.canvas.nativeElement, { 
        resize: true 
      });
    
      const test: any = myConfetti({
        particleCount: this.particle_count,
        spread: this.spread,
        origin: this.origin,
      });
    
      // Clear confetti after a certain duration
      setTimeout(() => myConfetti.reset(), this.duration);
    }
  }

}
